import { Grid, Typography } from '@mui/material';
import {
  Accessible,
  LocalBar,
  LocalParking,
  SmokeFree,
  Wifi,
  Power,
  Check,
} from '@mui/icons-material';
import PropTypes from 'prop-types';
import SimpleCard from '../../../../components/SimpleCard';
import { AMENITY_SPACE_STATUS } from '../../../../constants/event-application-status';
// import SimpleCard from '../../../../components/SimpleCard';

export default function AboutYourVenue({ event, freeFeatures, surcharges }) {
  return (
    <Grid container>
      <Grid item xs={12} md={2}>
        <Typography variant="h6" fontWeight="bold">
          About your venue:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography variant="h5" color="#EE7B57" textAlign="center">
          {event?.venue?.name}
        </Typography>
        <Typography variant="h6" textAlign="center">
          This venue is located at {`${event?.street_address} `}
          {event?.city !== null && event?.city?.name}
          {` `}
          {event?.state !== null && event?.state?.name}
        </Typography>
        <SimpleCard>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Typography variant="h7" fontWeight="bold">
                Venue features:
              </Typography>
              <Grid container marginTop={2}>
                {freeFeatures?.map((item) => (
                  <Grid item key={item.id} marginTop={2} margin={1.3}>
                    <img style={{ width: 30 }} src={item.Icon} alt={item.name} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item md>
              <Typography variant="h7" fontWeight="bold">
                Additional features:
              </Typography>
              {surcharges?.length > 0 ? (
                <Grid container paddingY={2}>
                  {surcharges?.map(
                    (i) =>
                      i.status === AMENITY_SPACE_STATUS.ENABLED && (
                        <Grid item md={6} key={i.id}>
                          <Check />
                          <span>{i.name}</span>
                        </Grid>
                      ),
                  )}
                </Grid>
              ) : (
                <Grid container paddingY={2}>
                  <Typography variant="body2">Without additional features...</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        </SimpleCard>
      </Grid>
    </Grid>
  );
}

function IconsContainer() {
  const iconSize = 'large';
  return (
    <div style={{ borderRight: 'solid', margin: '1rem', textAlign: 'center' }}>
      <Grid container paddingY={2}>
        <Grid item xs>
          <Accessible fontSize={iconSize} />
        </Grid>
        <Grid item xs>
          <LocalBar fontSize={iconSize} />
        </Grid>
        <Grid item xs>
          <LocalParking fontSize={iconSize} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs>
          <SmokeFree fontSize={iconSize} />
        </Grid>
        <Grid item xs>
          <Wifi fontSize={iconSize} />
        </Grid>
        <Grid item xs>
          <Power fontSize={iconSize} />
        </Grid>
      </Grid>
      <small>Recommended for ages 14+</small>
    </div>
  );
}

AboutYourVenue.propTypes = {
  event: PropTypes.instanceOf(Object).isRequired,
  freeFeatures: PropTypes.instanceOf(Object).isRequired,
  surcharges: PropTypes.instanceOf(Object).isRequired,
};
